import { render, staticRenderFns } from "./ChooseRole.vue?vue&type=template&id=56a4ab8e&scoped=true&"
import script from "./ChooseRole.vue?vue&type=script&lang=js&"
export * from "./ChooseRole.vue?vue&type=script&lang=js&"
import style0 from "./ChooseRole.vue?vue&type=style&index=0&id=56a4ab8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a4ab8e",
  null
  
)

export default component.exports